import { useQuery } from 'react-query';
import { getLocationData } from '@frontend/api-location';
import { ContextlessQueryObserverOptions } from '@frontend/react-query-helpers';

export const getCurrentLocationQueryKey = (locationId: string) => ['current-location', locationId];

export const useCurrentLocationQuery = (locationId?: string, opts?: ContextlessQueryObserverOptions) => {
  const { data, isLoading, ...query } = useQuery({
    ...opts,
    queryKey: getCurrentLocationQueryKey(locationId || ''),
    queryFn: () => {
      return getLocationData({ locationId: locationId || '' });
    },
    enabled: !!locationId,
  });

  return {
    ...query,
    currentLocation: data,
    isLoadingLocation: isLoading,
  };
};
